import CountTo from './CountTo.vue'
CountTo.install = function (Vue) {
  Vue.component(CountTo.name, CountTo)
}
export {
  CountTo
}
